import { AnimatePresence, motion } from 'motion/react';
import useLocalStorage from './hooks/useLocalStorage';
import { useController } from './hooks/useController';

import { VoteFullSize } from './components/VoteFullSize/VoteFullSize';
// import { QuestionSpeaker } from './components/QuestionSpeaker/QuestionSpeaker';
import { EmptyPage } from './components/EmptyPage/EmptyPage';

import { getOrCreateUserId } from './helpers/userId';

import logo from './assets/images/logo.png';
import { useVotes } from './context/VotesContext';

const STORAGE_KEY = 'vote_authorId';

function App() {
  const { votes, setVote } = useVotes();

  const [authorId, setUserId] = useLocalStorage(
    STORAGE_KEY,
    getOrCreateUserId(STORAGE_KEY),
  );

  const { isActive, voteState, idVote } = useController(authorId);

  return (
    <div className="app-wrapper">
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.5 }}
        className="logoBlock"
      >
        <img src={logo} alt="" />
      </motion.div>

      {isActive !== null ? (
        <div className="titre-wrapper">
          <AnimatePresence mode="wait">
            {!isActive ? (
              <motion.div
                style={{ width: '100%' }}
                key={`${isActive}-question`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                exit={{ opacity: 0 }}
              >
                {/* <QuestionSpeaker /> */}
                <EmptyPage />
              </motion.div>
            ) : (
              <motion.div
                style={{ width: '100%' }}
                key={`${idVote}-vote`}
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ duration: 0.5 }}
                exit={{ opacity: 0 }}
              >
                <VoteFullSize
                  variants={voteState?.vars}
                  title={voteState?.title}
                  idVote={idVote}
                  authorId={authorId}
                  votes={votes}
                  setVotes={setVote}
                />
              </motion.div>
            )}
          </AnimatePresence>
        </div>
      ) : null}
    </div>
  );
}

export default App;
